import React from 'react';
import { useParams } from 'react-router-dom';
import { useSampleById } from 'apollo/sample';
import { useStaticSeo } from 'hooks/useStaticSeo';
import { DynamicMetadata } from '../DynamicMetadata/DynamicMetadata';

export const Recommendation = () => {
    const { id } = useParams<{ id: string }>();
    const { loading, sample } = useSampleById(id);
    const staticSeo = useStaticSeo();

    if (loading || !sample) {
        return null;
    }

    return (
        <DynamicMetadata
            titleFallback={staticSeo.default.title}
            descriptionFallback={staticSeo.default.description}
            imageUrl={sample.pack?.artworkUrl}
            withWildcard={true}
        />
    );
};
